/**
 *
 * Asynchronously loads the component for Favorite
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
